var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignA(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H12.3744V6.18765H258.626V0H271V12.3744H264.813V258.625H271V270.999H258.626V264.813H12.3744V270.999H0V258.625H6.18722V12.3744H0V0ZM264.313 258.625H258.626V264.313H12.3744V258.625H6.68722V12.3744H12.3744V6.68765H258.626V12.3744H264.313V258.625Z",
    fill: "url(#paint0_linear_702_1096)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.395 60.8902L96.0401 159.045H162.42L129.395 60.8902ZM29 246V232.496L56.7407 228.214L127.083 24H147.889L218.231 229.531L243 232.496V246H153.173V232.496L185.537 228.543L167.373 174.525H90.7562L72.2623 228.214L104.627 232.496V246H29Z",
    fill: "url(#paint1_linear_702_1096)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_1096",
    x1: 5.24518,
    y1: 3.49676,
    x2: 318.206,
    y2: 337.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276869,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_1096",
    x1: 68.7428,
    y1: 15.8532,
    x2: 292.726,
    y2: 337.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320208,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignA);
export default __webpack_public_path__ + "static/media/design-A.966be40e06de37a50c3f27568c8bc405.svg";
export { ForwardRef as ReactComponent };